module.exports = __webpack_public_path__ + "static/media/soop_bowl.6ca56232.png";